import { useEffect, useState } from 'react';

export const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowWidth;
};

export const useArrowKeys = (onArrowRight: () => void, onArrowLeft: () => void, isFocused: boolean) => {
    useEffect(() => {
        const handleArrowKeys = (e: KeyboardEvent) => {
            if (isFocused) {
                if (e.key === 'ArrowRight' && onArrowRight) {
                    onArrowRight();
                } else if (e.key === 'ArrowLeft' && onArrowLeft) {
                    onArrowLeft();
                }
            }
        };

        window.addEventListener('keydown', handleArrowKeys);

        return () => {
            window.removeEventListener('keydown', handleArrowKeys);
        };
    }, [onArrowRight, onArrowLeft, isFocused]);
};
